import {type Writable, writable} from "svelte/store";


export const userInfo: Writable<userInfoInterface> = writable();
export const authToken: Writable<any> = writable();